export enum ObjectFit {
    none,
    fill,
    contain,
    cover,
    'scale-down'
}
